import * as React from 'react';
import { FunctionComponent } from 'react';

import { Modal, Heading, Text } from 'basecamp';

import { translate } from '../../../utils/locale';

type Props = {
	setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
};

const DeleteUserErrorModal: FunctionComponent<Props> = (props) => {
	return (
		<Modal
			setAs="small"
			close={() => props.setShowModal(false)}
			withCancelText={translate('manageUsers.modals.deleteUserError.OK') as string}
			andBodyPadY={4}
			dataTest="deleteUserErrorModal"
		>
			<Heading setAs="large" withColor="error" dataTest="deleteUserErrorModalTitle">
				{translate('manageUsers.modals.deleteUserError.TITLE') as string}
			</Heading>
			<Text mb={3} dataTest="deleteUserErrorModalBody">
				{translate('manageUsers.modals.deleteUserError.DESCRIPTION') as string}
			</Text>
		</Modal>
	);
};

export default DeleteUserErrorModal;
